import gql from 'graphql-tag';

export default fields => gql`
mutation ($input: CreateWebsiteInput!) {
    createWebsite (input: $input) {
        __typename
        ${[...['id', 'name'].concat(fields)]}
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Websites/NewMutation.js